/* eslint-disable ember/classic-decorator-no-classic-methods, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class SchoolGroupsController extends Controller {
  // Services
  @service
  store;

  // State
  @tracked
  groupDialogOpen = false;

  @tracked
  group = null;

  @action
  toggleGroupDialog() {
    this.toggleProperty('groupDialogOpen');
  }

  @action
  newGroup() {
    this.group = this.store.createRecord('schools/group');
    this.groupDialogOpen = true;
  }

  @action
  editGroup(group) {
    this.store.findRecord('schools/group', group.id).then((record) => {
      this.group = record;
      this.groupDialogOpen = true;
    });
  }
}
